<app-navbar-style-two></app-navbar-style-two>
<div class="privacy-policy-section">
  <div class="container">
    <div class="policy-header">
      <h1>Terms and Conditions</h1>
      <p>Welcome to The Tile Store – A Unit of Advika Enterprises Pvt. Ltd.<br>
        By accessing our website (thetilestore.in) and placing an order, you agree to be bound by the following terms and conditions:
      </p>
    </div>

    <div class="policy-content">
      <div class="policy-item">
        <h4>1. Product Information</h4>
        <ul>
          <li>We strive to ensure accurate product descriptions, images, pricing, and stock availability.</li>
          <li>Tile color, texture, and pattern may vary slightly due to lighting or screen display.</li>
          <li>Sizes are mentioned in approximate values and may vary ±2%.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>2. Orders and Pricing</h4>
        <ul>
          <li>Prices are inclusive of taxes unless otherwise mentioned.</li>
          <li>Offers and discounts are subject to change without prior notice.</li>
          <li>Order confirmation will be sent via email or WhatsApp upon successful payment.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>3. Delivery and Logistics</h4>
        <ul>
          <li>Delivery charges will be informed at the time of placing the order.</li>
          <li>Delivery timelines may vary based on location, product availability, and logistics.</li>
          <li>Customers must inspect the consignment upon delivery for any damage or shortage and report it within 24 hours.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>4. Payment Terms</h4>
        <ul>
          <li>We accept major online payment methods (UPI, bank transfer, credit/debit card).</li>
          <li>Full payment must be made prior to dispatch unless agreed otherwise in writing.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>5. Intellectual Property</h4>
        <ul>
          <li>All content, images, and designs on our website are the property of The Tile Store and may not be reused without permission.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>6. Governing Law</h4>
        <ul>
          <li>These terms are governed by the laws of India. Disputes are subject to Chennai jurisdiction.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
